/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import * as ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import {
  selectAdsShowBlockerConsent,
} from './ducks';


const adCheckElement = () => {
  const testAd = document.createElement('div');
  testAd.innerHTML = '&nbsp;';
  testAd.className = 'ads_box';
  document.body.appendChild(testAd);
};

const adBlockChecker = () => {
  const checkblock = document.querySelector('.ads_box');
  if (checkblock.offsetHeight === 0) {
    checkblock.remove();
    return true;
  }
  checkblock.remove();
  return false;
};

export const adBlockerActive = (blockConstent = false) => {
  
  const adsShowBlockerConsent = blockConstent ? false : useSelector(selectAdsShowBlockerConsent);
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    adCheckElement();
    window.setTimeout(() => {
      if (adBlockChecker() === true) {
        setDetected(true);
        ReactGA.event({
          category: 'Other',
          action: 'whitelisted',
          label: 'AdBlockerCheck',
        });
      }
    }, 1000);
  }, []);

  return detected && !adsShowBlockerConsent ? true : false;
};

export const AdBlockerUserWarning = ({ children }) => {
  return adBlockerActive() ? {...children} : null;
};